import { TableCell, TableHead, TableRow } from "@mui/material";
import { FormControlLabel, Radio, RadioGroup, FormHelperText } from "@mui/material";
import FormikTextField from "../../../commons/formik/FormikTextField";
import CharactersCounterLabel from "../../../commons/labels/CharactersCounterLabel";
import { useFormikContext } from "formik";

const OtrasActividadesRows = ({ columns }) => {

    const { values, errors, setFieldValue } = useFormikContext();
    return (
        <>
            <TableRow>
                <TableCell sx={{ borderBottom: 'none' }}>
                    Otras Actividades
                </TableCell>
                <TableCell sx={{ borderBottom: 'none' }}>
                    <RadioGroup
                        name={"otrasActividades"}
                        onChange={(v) => {
                            setFieldValue("otrasActividades", true);
                        }}
                    >
                        <FormControlLabel
                            control={
                                <Radio
                                    checked={
                                        values.otrasActividades === true
                                    }
                                />
                            }
                        />
                        < FormHelperText error >
                            {errors?.otrasActividades ?? ""}
                        </FormHelperText >
                    </RadioGroup >
                </TableCell>
                <TableCell sx={{ borderBottom: 'none' }}>
                    <RadioGroup
                        name={"otrasActividades"}
                        onChange={(v) => {
                            setFieldValue("otrasActividades", false);
                        }}
                    >
                        <FormControlLabel
                            control={
                                <Radio
                                    checked={
                                        values.otrasActividades === false
                                    }
                                />
                            }
                        />
                    </RadioGroup>
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell sx={{ px: 3, py: 2 }} colSpan={columns.length}>
                    <FormikTextField
                        multiline
                        rows={3}
                        variant="outlined"
                        name={`detalleOtrasActividades`}
                        label={"Detalles de Otras Actividades"}
                        fullWidth
                        onChange={(e) => {
                            if (e.target.value.trim()) {
                                setFieldValue(`otrasActividades`, true);
                            }
                        }}
                    />
                    <CharactersCounterLabel
                        value={values.otrasActividades ?? ""}
                        maxCharacters={100}
                    />
                </TableCell>
            </TableRow>
        </>
    )
}

export default OtrasActividadesRows;